import SDKMessageBus from '../utility/message-bus';

export default function refetchRequired(
    messageBus: SDKMessageBus,
    teardowns: (() => void)[],
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('refetchRequired')) {
        return;
    }

    return function(dataType: string, callback: () => void): () => void {
        const [category] = dataType.split('::');

        const sub = messageBus
            .onBroadcast<void>(`refetchRequired::${category}`)
            .subscribe(callback);
        const unsub = () => sub.unsubscribe();
        teardowns.push(unsub);

        return unsub;
    };
}
